import { gql } from '@apollo/client';

const ASSIGN_APPS = gql`
  mutation manageOperatorOrgApps($input: OperatorOrgInput!) {
    manageOperatorOrgApps(input: $input)
  }
`;

export { ASSIGN_APPS };
